import { calculateMetrics } from './processor';

export const prepareMetrics = (transactions) => {
  return calculateMetrics(transactions);
};
